import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {TasksApiPath} from '../../../consts'
import {ProcessWorkOrderDto} from '../../../types'

export const ProcessWorkOrderQueryKey = 'process-work-order'

const INTERVAL_PERIOD_IN_MS = 30000

type UseProcessWorkOrderTaskOptions = UseQueryOptions<ProcessWorkOrderDto | undefined, AxiosError>

type Params = {
  plantId?: string
  externalId: string
}

export const useProcessWorkOrder = (
  {plantId, externalId}: Params,
  options?: UseProcessWorkOrderTaskOptions
) => {
  const path = `${TasksApiPath.PROCESS_WORK_ORDERS}/${plantId}/process-work-orders/${externalId}`

  return useQuery<ProcessWorkOrderDto | undefined, AxiosError>({
    queryKey: [ProcessWorkOrderQueryKey, externalId, plantId],
    queryFn: async ({signal}) => {
      const {data} = await ApiClient.axiosInstance.get<ProcessWorkOrderDto>(path, {signal})

      return data
    },
    refetchInterval: INTERVAL_PERIOD_IN_MS,
    ...options
  })
}
